import React, { useState, useEffect } from 'react';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import StyledModal from './StyledModal';

export default function AgentMarxSingle({
  data,
  flag,
  index,
  onClickRemoveMarxRecord,
  userAccessToken,
  userId,
  userFlagsData,
}) {
  var webAPI = new MedicareProAPI.WebAPI();
  webAPI.setAccessToken(userAccessToken);

  var individualMarxRepository = new MedicareProAPI.IndMarxRepository();
  individualMarxRepository.setAccessToken(userAccessToken);

  var individualRepository = new MedicareProAPI.IndRepository();
  individualRepository.setAccessToken(userAccessToken);

  var individualPolicyRepository = new MedicareProAPI.IndPolicyRepository();
  individualPolicyRepository.setAccessToken(userAccessToken);

  var planRepository = new MedicareProAPI.PlanRepository();
  planRepository.setAccessToken(userAccessToken);

  var individualFlagRepository = new MedicareProAPI.IndFlagRepository();
  individualFlagRepository.setAccessToken(userAccessToken);

  const marxId = data.getId();
  const indId = data.getInd().getIndId();

  const [isDismissing, setIsDismissing] = useState(false);
  const [isAddingPlan, setIsAddingPlan] = useState(false);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [noAddressFound, setNoAddressFound] = useState(false);
  const [noPlansFound, setNoPlansFound] = useState(false);

  const [flagModalShow, setFlagModalShow] = useState(false);
  const [savingFlag, setSavingFlag] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState();

  const [selectedAddPlanStatus, setSelectedAddPlanStatus] = useState(false);
  const [savingAddPlanSelected, setSavingAddPlanSelected] = useState(false);
  const [addPlanModalShow, setAddPlanModalShow] = useState(false);
  const [addPlanStatusSelected, setAddPlanStatusSelected] = useState('Active');

  let futureEffectiveIsPast = false;
  if (data.getFutureEnrollmentDate()) {
    const today = new Date();
    const futureEffectiveDate = new Date(data.getFutureEnrollmentDate());

    futureEffectiveDate < today ? (futureEffectiveIsPast = true) : '';
  }

  const handleRemoveMarxRecord = () => {
    // Being passed from MarxButton
    if (onClickRemoveMarxRecord) {
      onClickRemoveMarxRecord(flag, marxId);
    }
  };

  const handleUserFlagSelected = (e) => {
    const value = e.target.value;

    if (value) {
      setSelectedFlag(value);
    }
  };

  const handleSaveUserFlagSelected = () => {
    setSavingFlag(true);
    let payload = {
      indId: indId,
      indFlagged: selectedFlag,
    };
    payload = [payload];
    individualFlagRepository.deleteIndsFlag(payload).then((response) => {
      individualFlagRepository.addIndsFlag(payload).then((response) => {
        setSavingFlag(false);
        setFlagModalShow(false);
        setSelectedFlag(false);

        // We dont want to automatically resolve the record as they might have multiple flags
        // Figure out better block for this, no time
        if (data.isCurrentPlanFlag() && data.isFuturePlanFlag()) {
          // We just want to remove this flag
          handleMarxUpdate(flag, 0);
        } else {
          handleMarxUpdate('resolved', 1);
        }
      });
    });
  };

  const handleOpenFlagModal = () => {
    // get users flags
    setFlagModalShow(true);

    /* if (userFlagsData.length === 0) {

            userFlagRepository.getUserFlags(userId).then(flags => {
                setUserFlagsData(flags.getItems());
            })
        } */
  };

  const handleMarxUpdate = (field, value) => {
    const payload = {};
    payload[field] = value;

    individualMarxRepository.updateIndMarx(marxId, payload).then((response) => {
      handleRemoveMarxRecord();
    });
  };

  const handleMarxDismiss = (field, value) => {
    setIsDismissing(true);

    if (!data.isCurrentPlanFlag() && !data.isFuturePlanFlag() == 0) {
      handleMarxUpdate('resolved', 1);
    } else {
      handleMarxUpdate(flag, 0);
    }
  };

  const handleIndStatusInactiveUpdate = () => {
    setIsUpdatingStatus(true);

    const payload = { indStatus: 'Inactive Client' };

    individualRepository.updateInd(indId, payload).then((response) => {
      const policyTerm =
        flag == 'futurePlanFlag' ? data.getFutureEnrollmentDate() : data.getCurrentEnrollmentDate();

      if (data.getInd().getPolicies().getItems().length > 0) {
        handleMarxUpdate(flag, 0);

        data
          .getInd()
          .getPolicies()
          .getItems()
          .forEach((policy) => {
            if (['Active', 'Pending'].includes(policy.getPolicyStatus())) {
              let payload = { PolicyStatus: 'Canceled', policyTermDate: policyTerm };
              let policyId = policy.getPolicyId();
              individualPolicyRepository
                .updateIndPolicy(indId, policyId, payload)
                .then((response) => {
                  setIsUpdatingStatus(false);
                });
            }
          });
      } else {
        setIsUpdatingStatus(false);
        handleMarxUpdate(flag, 0);
      }
    });
  };

  const handleIndStatusDeceasedUpdate = () => {
    setIsUpdatingStatus(true);

    const payload = { indStatus: 'Deceased' };

    individualRepository.updateInd(indId, payload).then((response) => {
      const policyTerm =
        flag == 'futurePlanFlag' ? data.getFutureEnrollmentDate() : data.getCurrentEnrollmentDate();

      if (data.getInd().getPolicies().getItems().length > 0) {
        data
          .getInd()
          .getPolicies()
          .getItems()
          .forEach((policy) => {
            if (['Active', 'Pending'].includes(policy.getPolicyStatus())) {
              let payload = { PolicyStatus: 'Canceled', policyTermDate: policyTerm };
              let policyId = policy.getPolicyId();
              individualPolicyRepository
                .updateIndPolicy(indId, policyId, payload)
                .then((response) => {
                  setIsUpdatingStatus(false);
                  handleMarxUpdate('resolved', 1);
                });
            }
          });
      } else {
        setIsUpdatingStatus(false);
        handleMarxUpdate('resolved', 1);
      }
    });
  };

  const handleIndPolicyAdd = () => {
    setIsAddingPlan(true);
    setNoPlansFound(false);
    setNoAddressFound(false);

    const address = data.getInd().getAnyDefaultAddress();
    const policies = data.getInd().getPolicies().getItems();

    // if (address) {

    //const state = address.getIndAddressState();
    //const county = address.getIndAddressCounty();
    const planNumber =
      flag == 'futurePlanFlag' ? data.getFutureContractNumber() : data.getCurrentContractNumber();
    const planName =
      flag == 'futurePlanFlag' ? data.getFuturePlanName() : data.getCurrentPlanName();

    const criteria = {
      criteria: {
        //  'planCounty' : (planName.indexOf('(PDP)') >= 0 ? 'All' : county),
        //  'planState' : state,
        planNumber: planNumber,
      },
      sortBy: 'planId',
      order: 'DESC',
      limit: 1,
      include: ['company'],
    };

    // Find plan in globPlans to add to ind
    planRepository.getPlans(criteria).then((response) => {
      if (response.getTotal() > 0) {
        const plan = response.getItems()[0];
        const planType = planNumber.charAt(0).toLowerCase() == 's' ? 'PDP' : 'MAPD';
        const policyEffective =
          flag == 'futurePlanFlag'
            ? data.getFutureEnrollmentDate()
            : data.getCurrentEnrollmentDate();
        // const policyStatus = (flag == 'futurePlanFlag' ? 'Pending' : 'Active');
        const policyStatus = addPlanStatusSelected;
        // See if there are other policies on account that this policy should replace
        const replaceStatus = ['Active', 'Pending'];
        const replacing = policies.filter((policy) => {
          return (
            policy.getPolicyType() == planType &&
            policy.getPolicyEffective() <= policyEffective &&
            replaceStatus.includes(policyStatus) &&
            policy.getPolicyStatus() == 'Active'
          );
        });

        var replacingIds = [];
        if (replacing.length > 0) {
          replacingIds = replacing.map((a) => a.getPolicyId());
        }

        const policyPayload = {
          policyCompany: plan.getCompany().getCompanyId(),
          policyPlan: plan.getPlanId(),
          policyType: planType,
          policyEffective: policyEffective,
          policyStatus: policyStatus,
          policyWasAgent: 1,
          policyWrittenAs: 'Like Plan Change',
        };

        if (replacingIds.length > 0 && policyStatus == 'Pending') {
          let replacedJoin = replacingIds.join(',');
          policyPayload['policyReplacing'] = replacedJoin;
        }

        // Add the policy
        individualPolicyRepository.addIndPolicy(indId, policyPayload).then((response) => {
          handleMarxUpdate(flag, 0);
          setIsAddingPlan(false);
          if (replacingIds.length > 0 && policyStatus == 'Active') {
            // Change the old policies to replaced
            replacingIds.forEach((policyId) => {
              handlePolicyUpdate(policyId, 'policyStatus', 'Replaced');
            });
          }
        });
      } else {
        setIsAddingPlan(false);
        setNoPlansFound(true);
      }
    });
    /*} else {
            setIsAddingPlan(false);
            setNoAddressFound(true);
        } */
  };

  const handlePolicyUpdate = (policyId, field, value) => {
    let payload = {};
    payload[field] = value;
    individualPolicyRepository.updateIndPolicy(indId, policyId, payload).then((response) => {});
  };

  const handleSaveAddPlanStatusSelected = (e) => {
    setSavingAddPlanSelected(true);

    setAddPlanModalShow(false);

    handleIndPolicyAdd();
    setSavingAddPlanSelected(false);
  };

  const handleAddPlanStatusSelected = (e) => {
    const value = e.target.value;

    if (value) {
      setAddPlanStatusSelected(value);
    }
  };

  return (
    <div className="row pb-2 mt-2 mx-2">
      <StyledModal
        size="md"
        title="Apply Flag"
        footerCloseButton={true}
        footerButtons={
          <button
            onClick={(e) => handleSaveUserFlagSelected()}
            className="btn btn-success"
            disabled={selectedFlag == '' ? true : false}
            type="button"
          >
            {savingFlag ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Saving
              </>
            ) : (
              <>Save</>
            )}
          </button>
        }
        show={flagModalShow}
        onClose={(e) => setFlagModalShow(false)}
      >
        <div className="row pl-3 pr-3">
          {userFlagsData.length > 0 && (
            <>
              <select
                className="form-control form-control-sm"
                onChange={(e) => handleUserFlagSelected(e)}
              >
                <option>Select...</option>
                {userFlagsData.map((flag) => {
                  return <option value={flag.getFlagColor()}>{flag.getFlagMeaning()}</option>;
                })}
              </select>
              <div className="alert alert-info p-1 mt-3" style={{ fontSize: '10pt' }}>
                <i className="far fa-flag mr-2"></i>Need more flags? Click{' '}
                <a href="https://www.medicareproapp.com/agent/settingsController/index/flags">
                  here
                </a>
                . <br></br>Or visit our{' '}
                <a target="_blank" href="https://medicareprocrm.frontkb.com/en/categories/617025">
                  help guide
                </a>{' '}
                to learn more about flags
              </div>
            </>
          )}
          {userFlagsData.length === 0 && <p>You don't have any flags set up.</p>}
        </div>
      </StyledModal>

      <StyledModal
        size="md"
        title="Plan Status"
        footerCloseButton={true}
        footerButtons={
          <button
            onClick={(e) => handleSaveAddPlanStatusSelected()}
            className="btn btn-success"
            disabled={addPlanStatusSelected == '' ? true : false}
            type="button"
          >
            {savingAddPlanSelected ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Saving
              </>
            ) : (
              <>Save</>
            )}
          </button>
        }
        show={addPlanModalShow}
        onClose={(e) => setAddPlanModalShow(false)}
      >
        <div className="row pl-3 pr-3">
          <label className="label">
            Select the status of the plan your going to add to the profile
          </label>
          <select
            className="form-control form-control-sm"
            onChange={(e) => handleAddPlanStatusSelected(e)}
          >
            <option value="Active">Active</option>
            <option value="Active-non">Active (not agent of record)</option>
            <option value="Pending">Pending</option>
            <option value="Replaced">Replaced</option>
            <option value="Canceled">Canceled</option>
            <option value="Disenrolled">Disenrolled</option>
            <option value="Declined">Declined</option>
          </select>
        </div>
      </StyledModal>

      <div className="col-12 mb-2">
        <strong>
          <i className="fal fa-user-circle mr-2"></i>
          {data.getInd().getIndName()}
        </strong>{' '}
        <small>
          <i>({data.getInd().getIndStatus()})</i>
        </small>{' '}
        <span className="badge badge-warning ml-2">Pushed on {data.getDateCreated()}</span>
      </div>

      {['currentPlanFlag', 'futurePlanFlag'].includes(flag) && (
        <>
          <div className="col-12">
            <div className="rounded p-3 greyCard d-inline-block">
              <div className="proCrdTitle">
                <strong>
                  {flag == 'currentPlanFlag' ? data.getCurrentPlanName() : data.getFuturePlanName()}
                  <>-</>
                  {flag == 'currentPlanFlag'
                    ? data.getCurrentContractNumber()
                    : data.getFutureContractNumber()}
                </strong>
              </div>
              <span class="polStatusBadge badge badge-success">
                <i className="far fa-spinner mr-1"></i>
                {flag == 'currentPlanFlag' ? 'Active' : 'Pending'}
              </span>
              <span class="polEffBadge badge badge-info ml-2">
                <i className="far fa-calendar-check mr-1"></i>
                {flag == 'currentPlanFlag'
                  ? data.getCurrentEnrollmentDate()
                  : data.getFutureEnrollmentDate()}
              </span>
              {flag == 'futurePlanFlag' && futureEffectiveIsPast && (
                <>
                  <br></br>
                  <span class="polEffBadge badge badge-danger">
                    <i className="far fa-exclamation-circle mr-1"></i>Caution: Future effective is
                    now old.
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="col-12  mt-3 pb-2">
            <span
              className="badge badge border border-secondary cp"
              onClick={() => setAddPlanModalShow(true)}
            >
              {isAddingPlan && <i class="fal fa-spinner fa-spin"></i>}
              {!isAddingPlan && (
                <>
                  <i className="fal fa-plus-circle mr-1"></i>Add Plan
                </>
              )}
            </span>
            <span
              className="badge badge border border-secondary cp ml-2 "
              onClick={() => handleIndStatusInactiveUpdate()}
            >
              {isUpdatingStatus && <i class="fal fa-spinner fa-spin"></i>}
              {!isUpdatingStatus && (
                <>
                  <i className="fal fa-minus-circle mr-1"></i>Mark as Inactive
                </>
              )}
            </span>
            <span
              className="badge badge border border-secondary cp ml-2"
              onClick={() => handleOpenFlagModal()}
            >
              {savingFlag && <i class="fal fa-spinner fa-spin"></i>}
              {!savingFlag && (
                <>
                  <i className="fal fa-flag mr-1"></i>Flag
                </>
              )}
            </span>
            <span
              className="badge badge border border-secondary cp ml-2"
              onClick={() => handleMarxDismiss(flag, 0)}
            >
              {isDismissing && <i class="fal fa-spinner fa-spin"></i>}
              {!isDismissing && (
                <>
                  <i className="fal fa-times-circle mr-1"></i>Dismiss
                </>
              )}
            </span>
            <span className="badge badge border border-secondary cp ml-2">
              <i className="fal fa-user-circle mr-1"></i>
              <a
                target="_blank"
                href={'/agent/profileController/index/' + data.getInd().getIndId()}
              >
                View Profile{' '}
              </a>
            </span>
          </div>
          <div className="col-12 border-bottom border-primary">
            {noPlansFound && (
              <div className="mt-2 mb-2 text-danger">
                <i className="far fa-exclamation-circle mr-1"></i>We could not match this plan in
                our system.
              </div>
            )}
            {noAddressFound && (
              <div className="mt-2 mb-2 text-danger">
                <i className="far fa-exclamation-circle mr-1"></i>This profile has no address in the
                system. This is required to match the plan listed here.
              </div>
            )}
          </div>
        </>
      )}

      {flag == 'deceasedFlag' && (
        <>
          <div className="col-12 border-bottom border-primary mt-2 pb-2">
            <span
              className="badge badge border border-danger cp ml-2"
              onClick={() => handleIndStatusDeceasedUpdate()}
            >
              {isUpdatingStatus && <i class="fal fa-spinner fa-spin"></i>}
              {!isUpdatingStatus && (
                <>
                  <i className="fal fa-heart-circle mr-1"></i>Mark as Deceased
                </>
              )}
            </span>
            <span
              className="badge badge border border-secondary cp ml-2"
              onClick={() => handleOpenFlagModal()}
            >
              {savingFlag && <i class="fal fa-spinner fa-spin"></i>}
              {!savingFlag && (
                <>
                  <i className="fal fa-flag mr-1"></i>Flag
                </>
              )}
            </span>
            <span
              className="badge badge border border-secondary cp ml-2"
              onClick={() => handleMarxDismiss('resolved', 1)}
            >
              {isDismissing && <i class="fal fa-spinner fa-spin"></i>}
              {!isDismissing && (
                <>
                  <i className="fal fa-times-circle mr-1"></i>Dismiss
                </>
              )}
            </span>
            <span className="badge badge border border-secondary cp ml-2">
              <i className="fal fa-user-circle mr-1"></i>
              <a
                target="_blank"
                href={'/agent/profileController/index/' + data.getInd().getIndId()}
              >
                View Profile{' '}
              </a>
            </span>
          </div>
        </>
      )}
      {flag == 'badMbiFlag' && (
        <>
          <div className="col-12 border-bottom border-primary mt-2 pb-2">
            <span
              className="badge badge border border-secondary cp ml-2"
              onClick={() => handleOpenFlagModal()}
            >
              {savingFlag && <i class="fal fa-spinner fa-spin"></i>}
              {!savingFlag && (
                <>
                  <i className="fal fa-flag mr-1"></i>Flag
                </>
              )}
            </span>
            <span
              className="badge badge border border-secondary cp ml-2"
              onClick={() => handleMarxDismiss('resolved', 1)}
            >
              {isDismissing && <i class="fal fa-spinner fa-spin"></i>}
              {!isDismissing && (
                <>
                  <i className="fal fa-times-circle mr-1"></i>Dismiss
                </>
              )}
            </span>
            <span className="badge badge border border-secondary cp ml-2">
              <i className="fal fa-user-circle mr-1"></i>
              <a
                target="_blank"
                href={'/agent/profileController/index/' + data.getInd().getIndId() + '/privateInfo'}
              >
                View Profile{' '}
              </a>
            </span>
          </div>
        </>
      )}
    </div>
  );
}
